export enum ActionTypes {
  POST_UPDATE = 'POST_UPDATE',
  POST_SET_MANY = 'POST_UPDATE_MANY',
  POST_REMOVED = 'POST_REMOVED',
  UPDATE_LATEST_POST_FOR_BLOCK = 'UPDATE_LATEST_POST_FOR_BLOCK',
  PORTFOLIO_POST_SET_MANY = 'PORTFOLIO_POST_SET_MANY',
  UPDATE_COMMENT_COUNT = 'UPDATE_COMMENT_COUNT',
  SHARE_POST_START = 'SHARE_POST_START',
  SHARE_POST_SUCCESS = 'SHARE_POST_SUCCESS',
  SHARE_POST_FAILED = 'SHARE_POST_FAILED',
}

export interface PostUpdateAction {
  type: ActionTypes.POST_UPDATE;
}

export interface PostSetManyAction {
  type: ActionTypes.POST_SET_MANY;
}

export interface PostRemovedAction {
  type: ActionTypes.POST_REMOVED;
}

export interface UpdateLatestPostForBlockAction {
  type: ActionTypes.UPDATE_LATEST_POST_FOR_BLOCK;
}

export interface PortfolioPostSetManyAction {
  type: ActionTypes.PORTFOLIO_POST_SET_MANY;
}

export interface UpdateCommentCountAction {
  type: ActionTypes.UPDATE_COMMENT_COUNT;
}
export interface SharePostStart {
  type: ActionTypes.SHARE_POST_START;
  blockId: string;
}

export interface SharePostSuccess {
  type: ActionTypes.SHARE_POST_SUCCESS;
  blockId: string;
}

export interface SharePostFailed {
  type: ActionTypes.SHARE_POST_FAILED;
  blockId: string;
}

export interface UpdateCommentCount {
  type: ActionTypes.UPDATE_COMMENT_COUNT;
}

export type PostAction =
  | PostUpdateAction
  | PostSetManyAction
  | PostRemovedAction
  | UpdateLatestPostForBlockAction
  | PortfolioPostSetManyAction
  | UpdateCommentCountAction
  | SharePostStart
  | SharePostSuccess
  | SharePostFailed
  | UpdateCommentCount;
